import React from 'react';
import PropTypes from 'prop-types';

// inner imports
import { BAND, MUSICIAN, LIVE_MUSIC, SERVICE } from '../../../../../consts';
import { capitalizeAll, isBandFinderType } from '../../../../../utils';

// icons imports
import MdAdd from 'react-icons/lib/md/add';

// css imports
import './styles.css';

const CategoryCards = ({ type, dataTypes, onNewCardClick, onDelete, onEdit, onHide }) => {
    const renderCards = () => {
        if (!dataTypes) return null;

        return dataTypes.categories[type].map((c, i) => {
            if (!isBandFinderType(type)) {
                return (
                    <div key={i} className={`card ${type}`}>
                        <span>{c.text}</span>
                        <div className="marker-image-wrapper">
                            <img src={c.images[2].src} alt="category"/>
                        </div>
                        <div className="actions">
                            <a className={`hide-btn`} onClick={() => onHide(c, type)}>{c.isHidden ? 'Hidden': 'Showing'}</a>|
                            <a onClick={() => onEdit(c, type)}>Edit</a>|
                            <a onClick={() => onDelete(c.name, type, i)}>Delete</a>
                        </div>
                    </div>
                )
            }

            return (
                <div key={i} className={`card ${type}`}>
                    <span className={type}>{c.text}</span>

                    <div className="actions">
                        <a onClick={() => onEdit(c, type)}>Edit</a>|<a onClick={() => onDelete(c.name, type, i)}>Delete</a>
                    </div>
                </div>
            )
        })
    };

    const renderHeader = () => {
        if (type === BAND) {
            return capitalizeAll(type);
        }

        if (type === MUSICIAN) {
            return capitalizeAll(type);
        }

        if (type === SERVICE) {
            return capitalizeAll(type);
        }

        if (type === LIVE_MUSIC) {
            return 'Live Event';
        }
    };

    return (
        <div className="category-cards-wrapper">
            <div className="content">
                <div className={`categories-cards-header ${type}`}>
                    {renderHeader()} Categories
                </div>
                <div className="cards">
                    <div className={`card add-card ${type}`} onClick={() => onNewCardClick(type)}>
                        <div className={`add-circle ${type}`}>
                            <i><MdAdd /></i>
                        </div>
                    </div>
                    {renderCards()}
                </div>
            </div>
        </div>
    )
};

CategoryCards.propTypes = {
    type: PropTypes.string,
    dataTypes: PropTypes.object,
    onNewCardClick: PropTypes.func,
    onDelete: PropTypes.func,
    onEdit: PropTypes.func,
    onHide: PropTypes.func
};

export default CategoryCards;



// WEBPACK FOOTER //
// ./src/Components/Screens/Admin/AdminComponents/CategoryCards/CategoryCards.js